module.exports = __webpack_public_path__ + "static/media/2P.64974ceb.svg";